import React from "react";
import wordIcon from "../static/word.svg";
import xlsxIcon from "../static/xlsx.svg";
import txtIcon from "../static/txt.svg";
import imgIcon from "../static/img.svg";
import pdfIcon from "../static/pdf.svg";
// import AttachFileIcon from "@mui/icons-material/AttachFile";

import closeIcon from "../static/close.svg";

// import { setPhotoViewActions } from "@/stores/photoViewActions";

const fileIcons: Record<string, string> = {
  doc: wordIcon,
  docx: wordIcon,
  xls: xlsxIcon,
  xlsx: xlsxIcon,
  txt: txtIcon,
  jpg: imgIcon,
  jpeg: imgIcon,
  png: imgIcon,
  gif: imgIcon,
  bmp: imgIcon,
  webp: imgIcon,
  pdf: pdfIcon,
};

// 图片后缀
const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

interface Props {
  fileName?: string;
  fileType?: string;
  removeFile?: () => void;
  base64?: string;
  url?: string;
  img_obj?: any;
  isMessage?: boolean;
  onGetItem?: () => void;
}

const Header: React.FC<Props> = ({
  fileType,
  removeFile,
  fileName,
  base64,
  url,
  img_obj,
  isMessage,
  onGetItem,
}) => {
  const iconSrc =
    fileType && fileIcons[fileType] ? fileIcons[fileType] : undefined;
  const isImage = fileType && imageExtensions.includes(fileType);
  // console.log(123456, isImage)

  const Icon = () => {
    if (isImage && img_obj?.url) {
      return (
        <img
          onClick={() => {
            // img_obj.url && setPhotoViewActions([img_obj.url], 0);
          }}
          style={{
            maxWidth: isMessage ? "100%" : "56px",
            maxHeight: isMessage ? "100%" : "56px",
          }}
          src={img_obj.url}
        />
      );
    }

    if (iconSrc) {
      return <img style={{ width: "40px", height: "40px" }} src={iconSrc} />;
    } else {
      // return <AttachFileIcon />;
      return null;
    }
  };
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: isImage ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
        width: "auto",
        height: isMessage && isImage ? "128px" : "64px",
        background: "#FFFFFF",
        borderRadius: "5px",
        border: "1px solid #EBEDEF",
        padding: isImage ? "5px" : "8px 12px 8px 8px",
        maxWidth: isMessage && isImage ? "387px" : "187px",
      }}
      className="group "
    >
      <Icon />
      {!base64 && fileName && (
        <div
          style={{
            fontSize: "10px",
            color: "#333",
            display: isImage && img_obj?.url ? "none" : "flex",
            flexDirection: isImage ? "row" : "column",
            textAlign: isImage ? "center" : "left",
          }}
          className={
            "truncate  w-[200px] px-[4px] pt-[6px] overflow-hidden flex-1"
          }
        >
          {!isImage && (
            <>
              <p
                style={{
                  fontSize: "12px",
                  margin: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {fileName}
              </p>
              <p
                style={{
                  fontSize: "12px",
                  margin: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {fileType}
              </p>
            </>
          )}
        </div>
      )}
      {/* {!isImage && (
        <div
          className="w-[26px] hidden group-hover:flex justify-center items-center cursor-pointer  h-[26px] rounded-[4px] hover:bg-[#72768b29]"
          onClick={() => {
            // console.log(url)
            if (onGetItem) {
              onGetItem();
            }
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M46.967 32.397c-.926-.076-2.054-.076-3.378-.076h-.178c-1.324 0-2.452 0-3.378.076-.777.063-1.536.187-2.272.469.098-6.499.82-10.02 2.175-12.433 1.437-2.555 3.746-4.177 8.038-6.727a2.25 2.25 0 0 0-2.298-3.869c-4.208 2.5-7.561 4.654-9.662 8.392-2.076 3.692-2.764 8.614-2.764 16.218v8.213c0 1.324 0 2.452.076 3.378.08.973.253 1.92.714 2.825a7.25 7.25 0 0 0 3.169 3.168c.904.461 1.85.635 2.824.715.926.075 2.054.075 3.378.075h.178c1.324 0 2.452 0 3.378-.075.973-.08 1.92-.254 2.824-.715a7.25 7.25 0 0 0 3.169-3.168c.46-.905.635-1.852.714-2.825.076-.926.076-2.054.076-3.378v-.177c0-1.325 0-2.453-.076-3.38-.08-.972-.253-1.919-.714-2.823a7.25 7.25 0 0 0-3.169-3.169c-.904-.46-1.85-.635-2.824-.714m-25.999 0c-.926-.076-2.054-.076-3.378-.076h-.177c-1.325 0-2.453 0-3.38.076-.776.063-1.535.187-2.27.469.097-6.499.818-10.02 2.174-12.433 1.437-2.555 3.746-4.177 8.038-6.727a2.25 2.25 0 0 0-2.298-3.869c-4.208 2.5-7.561 4.654-9.662 8.392C7.939 21.92 7.25 26.843 7.25 34.447v8.213c0 1.324 0 2.452.076 3.378.08.973.253 1.92.714 2.825a7.25 7.25 0 0 0 3.168 3.168c.905.461 1.852.635 2.825.715.926.075 2.054.075 3.378.075h.178c1.324 0 2.452 0 3.378-.075.973-.08 1.92-.254 2.824-.715a7.25 7.25 0 0 0 3.169-3.168c.46-.905.635-1.852.714-2.825.076-.926.076-2.054.076-3.378v-.177c0-1.325 0-2.453-.076-3.38-.08-.972-.253-1.919-.714-2.823a7.25 7.25 0 0 0-3.169-3.169c-.904-.46-1.85-.635-2.824-.714z"
              fill="black"
            ></path>
          </svg>
        </div>
      )} */}

      {removeFile && (
        <img
          onClick={removeFile}
          style={{
            width: "15px",
            height: "15px",
            position: "absolute",
            cursor: "pointer",
            top: "2px",
            right: "2px",
            background: "rgba(0, 0, 0, 0.1)",
            borderRadius: "50%",
            padding: "3px",
          }}
          src={closeIcon}
        />
      )}
    </div>
  );
};

export default Header;
